import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import DashboardIcon from '@material-ui/icons/Dashboard';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import DomainIcon from '@material-ui/icons/Domain';
import LocalDrinkIcon from '@material-ui/icons/LocalDrink';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import BarChartIcon from '@material-ui/icons/BarChart';
import SecurityIcon from '@material-ui/icons/Security';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import LayersIcon from '@material-ui/icons/Layers';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

import CommandCentre from './CommandCentre.jsx';
import Demand from './Demand.jsx';
import Production from './Production.jsx';
import BottlingCapacity from './BottlingCapacity.jsx';
import Inventory from './Inventory.jsx';
import DeploymentLogistics from './DeploymentLogistics.jsx';
import SalesChannels from './SalesChannels.jsx';
import Risk from './Risk.jsx';
import Finance from './Finance.jsx';
import Scenarios from './Scenarios.jsx';
import Initiatives from './Initiatives.jsx';
import AskEPM from './AskEPM.jsx';
import './index.scss';

const TAB_CONFIG = [
    { label: 'Command Centre', icon: DashboardIcon, color: '#2563eb' },
    { label: 'Demand', icon: ShowChartIcon, color: '#0d9488' },
    { label: 'Production', icon: DomainIcon, color: '#7c3aed' },
    { label: 'Bottling & Capacity', icon: LocalDrinkIcon, color: '#ea580c' },
    { label: 'Inventory', icon: ShoppingCartIcon, color: '#2563eb' },
    { label: 'Deployment & Logistics', icon: DeviceHubIcon, color: '#0891b2' },
    { label: 'Sales & Channels', icon: BarChartIcon, color: '#16a34a' },
    { label: 'Risk', icon: SecurityIcon, color: '#db2777' },
    { label: 'Finance', icon: AccountBalanceIcon, color: '#1e3a8a' },
    { label: 'Scenarios', icon: LayersIcon, color: '#7c3aed' },
    { label: 'Initiatives', icon: EmojiObjectsIcon, color: '#ca8a04' },
    { label: 'AskEPM', icon: ChatBubbleOutlineIcon, color: '#be185d' },
];

function TabLabel({ Icon, label }) {
    return (
        <span className="pa-tab-label">
            {/* <Icon className="pa-tab-icon" /> */}
            <span>{label}</span>
        </span>
    );
}

export class EnterprizeOptimization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0,
        };
    }

    handleTabChange = (event, newValue) => {
        this.setState({ tabValue: newValue });
    };

    renderTabPanel() {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <CommandCentre />;
            case 1:
                return <Demand />;
            case 2:
                return <Production />;
            case 3:
                return <BottlingCapacity />;
            case 4:
                return <Inventory />;
            case 5:
                return <DeploymentLogistics />;
            case 6:
                return <SalesChannels />;
            case 7:
                return <Risk />;
            case 8:
                return <Finance />;
            case 9:
                return <Scenarios />;
            case 10:
                return <Initiatives />;
            case 11:
                return <AskEPM />;
            default:
                return null;
        }
    }

    render() {
        const { tabValue } = this.state;

        return (
            <>
                <Tabs
                    value={tabValue}
                    onChange={this.handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    className="pa-tabs"
                    TabIndicatorProps={{ className: 'pa-tabs-indicator' }}
                >
                    {TAB_CONFIG.map(({ label, icon, color }, index) => (
                        <Tab
                            key={label}
                            className={`pa-tab ${tabValue === index ? 'pa-tab-active' : ''}`}
                            disableRipple
                            label={
                                <TabLabel
                                    Icon={icon}
                                    color={color}
                                    label={label}
                                    active={tabValue === index}
                                />
                            }
                        />
                    ))}
                </Tabs>
                {this.renderTabPanel()}
            </>
        );
    }
}

export default EnterprizeOptimization;